import { render, staticRenderFns } from "./seyas_pay.vue?vue&type=template&id=2bd87b78&scoped=true&"
import script from "./seyas_pay.vue?vue&type=script&lang=js&"
export * from "./seyas_pay.vue?vue&type=script&lang=js&"
import style0 from "./seyas_pay.vue?vue&type=style&index=0&id=2bd87b78&scoped=true&lang=less&"
import style1 from "./seyas_pay.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd87b78",
  null
  
)

export default component.exports